import React, { Component } from "react";
import { number, func } from "prop-types";

import { actions as campaignsActions } from "reducers/campaigns";

import Image from "pages/_components/Image";
import Button from "pages/_components/Button";

class CampaignHeader extends Component {
    static propTypes = {
        idCampaign: number.isRequired,
        dispatch: func.isRequired,
    };

    showModal = () => {
        const { idCampaign, dispatch } = this.props;
        dispatch(campaignsActions.showDisplayModal(idCampaign));
    };

    render() {
        return (
            // <header className="title-grid-container">
            <div style={{ display: "flex", justifyContent: "space-around" }}>
                <p className="">
                    <Button className="btn-only-icon btn-circle" onClick={() => this.showModal()}>
                        <Image className="svg-icon-small icon-link ml-4" src="images/figma/icon/cross.svg" />
                    </Button>
                </p>
            </div>
            // </header>
        );
    }
}

export default CampaignHeader;
